import { Component, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PiezeoDashboardService } from "../../../../../app/services/piezo-dashboard.service";
import { ConvertDatetimePipe } from "../../../../../app/convert-datetime.pipe";
import { BaseUrlConstantsService } from "../../../../../app/services/base-url-constants.service";
import { Subscription } from "rxjs";

interface Alert {
  type: string;
  timestamp: string;
  status: "critical" | "warning" | "resolved";
}

@Component({
  selector: "app-piezo-alerts",
  templateUrl: "./piezo-alerts.component.html",
  styleUrl: "./piezo-alerts.component.scss",
  standalone: true,
  imports: [CommonModule],
})
export class PiezoAlerts implements OnInit {
  public BHEL_ON_PREM: boolean = BaseUrlConstantsService.BHEL_ON_PREM;
  piezo_srv = inject(PiezeoDashboardService);

  piezo_asset_ids: number[] = [];
  emsaver_asset_ids: number[] = [];
  client_id = "";
  sub!: Subscription

  piezoAlerts: Alert[] = [];
  emsaverAlerts: Alert[] = [];
  alerts: Alert[] = [];

  intervalId: any;
  isLoading = true;
  private loadingStates = {
    piezo: false,
    emsaver: false,
  };

  constructor() { }

  ngOnInit() {
    // const { device_position, client_id } = this.piezo_srv.getSubsystemData();
    let subsystem_data = null;
    this.sub = this.piezo_srv.subsystem_data$.subscribe((data) => {
      subsystem_data = data;
      this.client_id = subsystem_data.client_id;
      const device_position = subsystem_data.device_position;

      const parsed =
        typeof device_position == "string"
          ? JSON.parse(device_position)
          : device_position;
      this.piezo_asset_ids = parsed.filter((s) => s.master_type == 4).map((s) => s.asset_id);
      this.emsaver_asset_ids = parsed.filter((s) => s.master_type != 4).map((s) => s.asset_id);

      this.fetchPiezoAlerts();
      this.fetchEmsaverAlerts();
    });

    // this.intervalId = setInterval(() => {
    //   this.fetchPiezoAlerts();
    //   this.fetchEmsaverAlerts();
    // }, 30000);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private checkLoadingComplete() {
    if (this.loadingStates.piezo && this.loadingStates.emsaver) {
      this.isLoading = false;
    }
  }

  fetchPiezoAlerts() {
    try {
      if (this.piezo_asset_ids.length === 0) {
        console.warn("No Piezo asset IDs found.");
        this.loadingStates.piezo = true;
        this.checkLoadingComplete();
        return;
      }

      const assetIdsString = this.piezo_asset_ids.join(",");

      this.piezo_srv
        .fetchPiezoAlerts(this.client_id, assetIdsString)
        .then((res: any[]) => {
          if (Array.isArray(res) && res.length > 0) {
            const piezoAlerts = res.map((alert) => ({
              type: alert.error || "Alert Detected",
              timestamp: new ConvertDatetimePipe().convertDateTime(alert.time),
              status: "critical" as const,
            }));

            this.piezoAlerts = piezoAlerts;
          }
        })
        .catch((err) => {
          console.error("Fetch Piezo Alerts Error:", err);
        })
        .finally(() => {
          this.loadingStates.piezo = true;
          this.checkLoadingComplete();
          this.mergeAlerts();
        });
    } catch (error) {
      console.error("fetchPiezoAlerts() Exception:", error);
    } finally {
      this.loadingStates.piezo = true;
      this.checkLoadingComplete();
      this.mergeAlerts();
    }
  }

  fetchEmsaverAlerts() {
    try {
      if (this.emsaver_asset_ids.length === 0) {
        console.warn("No Emsaver asset IDs found.");
        this.loadingStates.emsaver = true;
        this.checkLoadingComplete();
        return;
      }

      const assetIdsString = this.emsaver_asset_ids.join(",");

      this.piezo_srv
        .fetchEmsaverAlerts(this.client_id, assetIdsString)
        .then((res: any[]) => {
          if (Array.isArray(res) && res.length > 0) {
            const emsaverAlerts = res.map((alert) => ({
              type: alert.error || "Alert Detected",
              timestamp: new ConvertDatetimePipe().convertDateTime(alert.time),
              status: "critical" as const,
            }));

            this.emsaverAlerts = emsaverAlerts;
          }
        })
        .catch((err) => {
          console.error("Fetch Emsaver Alerts Error:", err);
        })
        .finally(() => {
          this.loadingStates.emsaver = true;
          this.checkLoadingComplete();
          this.mergeAlerts();
        });
    } catch (error) {
      console.error("fetchEmsaverAlerts() Exception:", error);
      this.loadingStates.emsaver = true;
      this.checkLoadingComplete();
    }
  }

  mergeAlerts() {
    this.alerts = [...this.piezoAlerts, ...this.emsaverAlerts];
  }
}
